import {
  Box,
  ColorScheme,
  ResponsiveValue,
  SpaceScale,
  Tag,
  TagColor,
  TagSize,
} from "@gocardless/flux-react";
import { Trans } from "@lingui/macro";

import { isSandboxEnvironment } from "./consts";

interface SandboxTagProps {
  spaceBelow?: ResponsiveValue<SpaceScale>;
}

export const SandboxTag = ({ spaceBelow }: SandboxTagProps) => (
  <>
    {isSandboxEnvironment && (
      <Box spaceBelow={spaceBelow}>
        <Tag
          color={TagColor.Primary}
          colorScheme={ColorScheme.OnDark}
          size={TagSize.Lg}
        >
          <Trans id="Sandbox">Sandbox</Trans>
        </Tag>
      </Box>
    )}
  </>
);
